<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="modal-form-rank">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Precintos por Rango</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="numero_inf">Num. de Precinto Inferior</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="numero_inf"
                    placeholder="Numero Inferior"
                    v-model="form.numero_inf"
                    :class="
                      $v.form.numero_inf.$invalid ? 'is-invalid' : 'is-valid'
                    "
                  />
                </div>
                <div class="error" v-if="!$v.form.numero_inf.required">
                  Ingrese un numero Inferior
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="numero_sup">Num. de Precinto Superior</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="numero_sup"
                    placeholder="Numero Superior"
                    v-model="form.numero_sup"
                    :class="
                      $v.form.numero_sup.$invalid ? 'is-invalid' : 'is-valid'
                    "
                  />
                </div>
                <div class="error" v-if="!$v.form.numero_sup.required">
                  Ingrese un numero Superior
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form.$invalid"
              @click="savePrecintos()"
            >
              Crear Precintos
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PrecintoRangos",
  components: {},
  data() {
    return {
      form: {
        numero_inf: null,
        numero_sup: null,
      },
    };
  },
  validations: {
    form: {
      numero_inf: {
        required,
      },
      numero_sup: {
        required,
      },
    },
  },
  methods: {
    limpiarModal() {
      this.form = {
        numero_inf: null,
        numero_sup: null,
      };
    },
    savePrecintos() {
      // Validar que los campos estén completos
      if (!this.form.numero_inf || !this.form.numero_sup) {
        this.$swal({
          icon: "warning",
          title: "Por favor complete todos los campos requeridos",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      if (this.form.numero_sup < this.form.numero_inf) {
        this.$swal({
          icon: "warning",
          title: "El número superior debe ser mayor o igual al número inferior",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      let me = this;
      this.$parent.cargando = true;
      axios
        .post("/api/argentina/precintos", this.form)
        .then(async (response) => {
          this.$parent.cargando = false;
          this.$refs.closeModal.click();
          await this.$parent.getIndex();
          await this.$parent.getGrafica();
          this.limpiarModal();
          this.$swal({
            icon: "success",
            title: response.data.msg || "Los precintos se crearon exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$parent.cargando = false;
          let res = Object.assign({}, e);
          let errorMsg = "Ocurrió un error, vuelva a intentarlo...";
          
          // Manejar errores de validación
          if (res.response?.data?.errors) {
            const errors = Object.values(res.response.data.errors).flat();
            errorMsg = errors.join(', ');
          } else if (res.response?.data?.msg) {
            errorMsg = res.response.data.msg;
          } else if (res.response?.data?.message) {
            errorMsg = res.response.data.message;
          }
          
          this.$swal({
            icon: "error",
            title: errorMsg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },
  },
};
</script>
